import React from "react";
import customerSectionImg from "../../../../images/customer-section-img.png";
import localeText from "../../../../../locale";

const CustomerInfoSection = () => (
  <div
    className="border-round-md p-3 flex flex-column md:flex-row justify-content-between align-items-start gap-3"
    style={{
      background: "linear-gradient(90deg, #7EE5C0CC 0%, #7EE5C000 80%)",
      overflow: "hidden",
    }}
  >
    <div className="flex-1">
      <div className="font-semibold mb-2" style={{ color: "#17633D" }}>
        {localeText("customerHomeFutureTitle") || "Em breve: novas funcionalidades para Customers."}
      </div>
      <p className="m-0 text-sm" style={{ color: "#17633D" }}>
        {localeText("customerHomeFutureSubtitle") ||
          "Estamos preparando recursos para ampliar as possibilidades de compra e serviços no seu painel."}
      </p>
    </div>
    <img
      src={customerSectionImg}
      alt={localeText("customerHomeFutureImageAlt") || "Customer section"}
      style={{ width: "230px", maxWidth: "100%", borderRadius: "0.5rem" }}
    />
  </div>
);

export default CustomerInfoSection;
